import { easeCubicInOut as Er, pointer as _r, min as Cr, extent as Mr, scaleLinear as $r, scaleQuantize as Ar } from "d3";
import { Z as mt, s as K, S as Yt, V as Qe, i as Sn, u as Dr, A as Ae, k as xr, K as De, x as Lr, p as Ir, Q as Rr, D as Fr } from "./enums-a96ef472.mjs";
import { b as ct, a as xe, c as Nr, d as Le } from "./index-becfb567.mjs";
function Xe(e) {
  "@babel/helpers - typeof";
  return Xe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xe(e);
}
function me(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function B(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Z(e) {
  B(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Xe(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Ur(e, t) {
  B(2, arguments);
  var n = Z(e).getTime(), r = me(t);
  return new Date(n + r);
}
var jr = {};
function nt() {
  return jr;
}
function Wr(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Hr(e) {
  return B(1, arguments), e instanceof Date || Xe(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Yr(e) {
  if (B(1, arguments), !Hr(e) && typeof e != "number")
    return !1;
  var t = Z(e);
  return !isNaN(Number(t));
}
function Br(e, t) {
  B(2, arguments);
  var n = me(t);
  return Ur(e, -n);
}
var Gr = 864e5;
function qr(e) {
  B(1, arguments);
  var t = Z(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), a = n - r;
  return Math.floor(a / Gr) + 1;
}
function Ke(e) {
  B(1, arguments);
  var t = 1, n = Z(e), r = n.getUTCDay(), a = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function On(e) {
  B(1, arguments);
  var t = Z(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Ke(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = Ke(o);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function Vr(e) {
  B(1, arguments);
  var t = On(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Ke(n);
  return r;
}
var zr = 6048e5;
function Qr(e) {
  B(1, arguments);
  var t = Z(e), n = Ke(t).getTime() - Vr(t).getTime();
  return Math.round(n / zr) + 1;
}
function Je(e, t) {
  var n, r, a, o, i, u, l, g;
  B(1, arguments);
  var f = nt(), m = me((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (g = l.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = Z(e), C = v.getUTCDay(), M = (C < m ? 7 : 0) + C - m;
  return v.setUTCDate(v.getUTCDate() - M), v.setUTCHours(0, 0, 0, 0), v;
}
function Pn(e, t) {
  var n, r, a, o, i, u, l, g;
  B(1, arguments);
  var f = Z(e), m = f.getUTCFullYear(), v = nt(), C = me((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : v.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = v.locale) === null || l === void 0 || (g = l.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(C >= 1 && C <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var M = /* @__PURE__ */ new Date(0);
  M.setUTCFullYear(m + 1, 0, C), M.setUTCHours(0, 0, 0, 0);
  var x = Je(M, t), P = /* @__PURE__ */ new Date(0);
  P.setUTCFullYear(m, 0, C), P.setUTCHours(0, 0, 0, 0);
  var U = Je(P, t);
  return f.getTime() >= x.getTime() ? m + 1 : f.getTime() >= U.getTime() ? m : m - 1;
}
function kr(e, t) {
  var n, r, a, o, i, u, l, g;
  B(1, arguments);
  var f = nt(), m = me((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (g = l.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), v = Pn(e, t), C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(v, 0, m), C.setUTCHours(0, 0, 0, 0);
  var M = Je(C, t);
  return M;
}
var Xr = 6048e5;
function Kr(e, t) {
  B(1, arguments);
  var n = Z(e), r = Je(n, t).getTime() - kr(n, t).getTime();
  return Math.round(r / Xr) + 1;
}
function A(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var Jr = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), a = r > 0 ? r : 1 - r;
    return A(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : A(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return A(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return A(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return A(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return A(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return A(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, a = t.getUTCMilliseconds(), o = Math.floor(a * Math.pow(10, r - 3));
    return A(o, n.length);
  }
};
const se = Jr;
var Oe = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Zr = {
  // Era
  G: function(t, n, r) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var a = t.getUTCFullYear(), o = a > 0 ? a : 1 - a;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return se.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, a) {
    var o = Pn(t, a), i = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var u = i % 100;
      return A(u, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : A(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = On(t);
    return A(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return A(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return A(a, 2);
      case "Qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return A(a, 2);
      case "qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var a = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return se.M(t, n);
      case "Mo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var a = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return A(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, a) {
    var o = Kr(t, a);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : A(o, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var a = Qr(t);
    return n === "Io" ? r.ordinalNumber(a, {
      unit: "week"
    }) : A(a, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : se.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var a = qr(t);
    return n === "Do" ? r.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : A(a, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var a = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, a) {
    var o = t.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return A(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, a) {
    var o = t.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return A(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var a = t.getUTCDay(), o = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return A(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var a = t.getUTCHours(), o = a / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var a = t.getUTCHours(), o;
    switch (a === 12 ? o = Oe.noon : a === 0 ? o = Oe.midnight : o = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var a = t.getUTCHours(), o;
    switch (a >= 17 ? o = Oe.evening : a >= 12 ? o = Oe.afternoon : a >= 4 ? o = Oe.morning : o = Oe.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return se.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : se.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var a = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : A(a, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : A(a, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : se.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : se.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return se.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return Gt(i);
      case "XXXX":
      case "XX":
        return de(i);
      case "XXXXX":
      case "XXX":
      default:
        return de(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return Gt(i);
      case "xxxx":
      case "xx":
        return de(i);
      case "xxxxx":
      case "xxx":
      default:
        return de(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Bt(i, ":");
      case "OOOO":
      default:
        return "GMT" + de(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Bt(i, ":");
      case "zzzz":
      default:
        return "GMT" + de(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, a) {
    var o = a._originalDate || t, i = Math.floor(o.getTime() / 1e3);
    return A(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTime();
    return A(i, n.length);
  }
};
function Bt(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(a);
  var i = t || "";
  return n + String(a) + i + A(o, 2);
}
function Gt(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + A(Math.abs(e) / 60, 2);
  }
  return de(e, t);
}
function de(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", a = Math.abs(e), o = A(Math.floor(a / 60), 2), i = A(a % 60, 2);
  return r + o + n + i;
}
const ea = Zr;
var qt = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, En = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, ta = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], a = r[1], o = r[2];
  if (!o)
    return qt(t, n);
  var i;
  switch (a) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", qt(a, n)).replace("{{time}}", En(o, n));
}, na = {
  p: En,
  P: ta
};
const ra = na;
var aa = ["D", "DD"], oa = ["YY", "YYYY"];
function ia(e) {
  return aa.indexOf(e) !== -1;
}
function sa(e) {
  return oa.indexOf(e) !== -1;
}
function Vt(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var ua = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, la = function(t, n, r) {
  var a, o = ua[t];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
const ca = la;
var fa = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, da = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ha = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ga = {
  date: ct({
    formats: fa,
    defaultWidth: "full"
  }),
  time: ct({
    formats: da,
    defaultWidth: "full"
  }),
  dateTime: ct({
    formats: ha,
    defaultWidth: "full"
  })
};
const ma = ga;
var pa = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ya = function(t, n, r, a) {
  return pa[t];
};
const va = ya;
var ba = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, wa = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ta = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Sa = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Oa = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Pa = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ea = function(t, n) {
  var r = Number(t), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, _a = {
  ordinalNumber: Ea,
  era: xe({
    values: ba,
    defaultWidth: "wide"
  }),
  quarter: xe({
    values: wa,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: xe({
    values: Ta,
    defaultWidth: "wide"
  }),
  day: xe({
    values: Sa,
    defaultWidth: "wide"
  }),
  dayPeriod: xe({
    values: Oa,
    defaultWidth: "wide",
    formattingValues: Pa,
    defaultFormattingWidth: "wide"
  })
};
const Ca = _a;
var Ma = /^(\d+)(th|st|nd|rd)?/i, $a = /\d+/i, Aa = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Da = {
  any: [/^b/i, /^(a|c)/i]
}, xa = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, La = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ia = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ra = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Fa = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Na = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ua = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ja = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Wa = {
  ordinalNumber: Nr({
    matchPattern: Ma,
    parsePattern: $a,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Le({
    matchPatterns: Aa,
    defaultMatchWidth: "wide",
    parsePatterns: Da,
    defaultParseWidth: "any"
  }),
  quarter: Le({
    matchPatterns: xa,
    defaultMatchWidth: "wide",
    parsePatterns: La,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Le({
    matchPatterns: Ia,
    defaultMatchWidth: "wide",
    parsePatterns: Ra,
    defaultParseWidth: "any"
  }),
  day: Le({
    matchPatterns: Fa,
    defaultMatchWidth: "wide",
    parsePatterns: Na,
    defaultParseWidth: "any"
  }),
  dayPeriod: Le({
    matchPatterns: Ua,
    defaultMatchWidth: "any",
    parsePatterns: ja,
    defaultParseWidth: "any"
  })
};
const Ha = Wa;
var Ya = {
  code: "en-US",
  formatDistance: ca,
  formatLong: ma,
  formatRelative: va,
  localize: Ca,
  match: Ha,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const _n = Ya;
var Ba = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ga = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, qa = /^'([^]*?)'?$/, Va = /''/g, za = /[a-zA-Z]/;
function pt(e, t, n) {
  var r, a, o, i, u, l, g, f, m, v, C, M, x, P, U, q, oe, V;
  B(2, arguments);
  var Q = String(t), le = nt(), w = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : le.locale) !== null && r !== void 0 ? r : _n, c = me((o = (i = (u = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (g = n.locale) === null || g === void 0 || (f = g.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && u !== void 0 ? u : le.firstWeekContainsDate) !== null && i !== void 0 ? i : (m = le.locale) === null || m === void 0 || (v = m.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(c >= 1 && c <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var y = me((C = (M = (x = (P = n == null ? void 0 : n.weekStartsOn) !== null && P !== void 0 ? P : n == null || (U = n.locale) === null || U === void 0 || (q = U.options) === null || q === void 0 ? void 0 : q.weekStartsOn) !== null && x !== void 0 ? x : le.weekStartsOn) !== null && M !== void 0 ? M : (oe = le.locale) === null || oe === void 0 || (V = oe.options) === null || V === void 0 ? void 0 : V.weekStartsOn) !== null && C !== void 0 ? C : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!w.localize)
    throw new RangeError("locale must contain localize property");
  if (!w.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var E = Z(e);
  if (!Yr(E))
    throw new RangeError("Invalid time value");
  var T = Wr(E), O = Br(E, T), s = {
    firstWeekContainsDate: c,
    weekStartsOn: y,
    locale: w,
    _originalDate: E
  }, d = Q.match(Ga).map(function(h) {
    var p = h[0];
    if (p === "p" || p === "P") {
      var S = ra[p];
      return S(h, w.formatLong);
    }
    return h;
  }).join("").match(Ba).map(function(h) {
    if (h === "''")
      return "'";
    var p = h[0];
    if (p === "'")
      return Qa(h);
    var S = ea[p];
    if (S)
      return !(n != null && n.useAdditionalWeekYearTokens) && sa(h) && Vt(h, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && ia(h) && Vt(h, t, String(e)), S(O, h, w.localize, s);
    if (p.match(za))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + p + "`");
    return h;
  }).join("");
  return d;
}
function Qa(e) {
  var t = e.match(qa);
  return t ? t[1].replace(Va, "'") : e;
}
const ka = "cds", Xa = {
  opacity: {
    unselected: 0.05,
    selected: 0.4
  }
}, Ka = {
  ticks: {
    number: 7,
    rotateIfSmallerThan: 30,
    verticalSpaceRatio: 2.5,
    horizontalSpaceRatio: 3.5
  },
  ratio: {
    reference: "value",
    compareTo: "marker"
  },
  paddingRatio: 0.1,
  hover: {
    rectanglePadding: 4
  }
}, Ja = {
  duration: 1e3,
  ease: Er,
  zoomLevel: 3
}, Cn = {
  circles: {
    fillOpacity: 0.3,
    hover: {
      stroke: "#FFF"
    }
  },
  padding: {
    mainGroup: 4,
    children: 2
  },
  hierarchyLevel: 2
}, Za = {
  pairingOptions: {
    "1-color": 4,
    "2-color": 5,
    "3-color": 5,
    "4-color": 3,
    "5-color": 2,
    "14-color": 1
  }
}, eo = {
  circle: {
    radius: 4,
    opacity: {
      hovered: 1,
      default: 0.3
    }
  },
  box: {
    opacity: {
      hovered: 0.5,
      default: 0.3
    }
  },
  strokeWidth: {
    default: 1,
    thicker: 2
  }
}, to = {
  defaultBins: 10
}, no = {
  items: {
    status: {
      ACTIVE: 1,
      DISABLED: 0
    },
    horizontalSpace: 12,
    verticalSpace: 24,
    textYOffset: 8,
    spaceAfter: 4
  },
  checkbox: {
    radius: 6.5
  },
  radius: {
    iconData: [
      { cx: 7, cy: 7, r: 6.5 },
      { cx: 7, cy: 10, r: 3.5 }
    ],
    fill: null,
    stroke: "#8c8c8c"
  },
  line: {
    yPosition: 6,
    width: 24,
    strokeWidth: 1.4,
    fill: null,
    stroke: "#999999"
  },
  area: {
    width: 24,
    height: 14,
    fill: "#6f6f6f",
    stroke: null
  },
  size: {
    iconData: [
      { width: 23, height: 12 },
      { width: 13, height: 6 }
    ],
    fill: null,
    stroke: "#8D8D8D"
  },
  quartile: {
    iconData: [
      { x: 0, y: 0, width: 24, height: 13 },
      { x: 11, y: 4, width: 1, height: 4 }
    ]
  },
  zoom: {
    iconData: [{ x: 0, y: 0, width: 12, height: 12 }],
    color: "#8D8D8D"
  },
  color: {
    barWidth: 300,
    barHeight: 8,
    axisYTranslation: 10
  }
}, ro = {
  opacity: {
    unselected: 0.3,
    selected: 1
  },
  weight: {
    selected: 2,
    unselected: 1
  }
}, ao = {
  statusBar: {
    paddingRight: 5
  },
  status: {
    indicatorSize: 16,
    paddingLeft: 15
  },
  total: {
    paddingLeft: 36,
    paddingRight: 24
  },
  height: {
    default: 8,
    proportional: 16
  },
  dividerWidth: 2
}, oo = {
  radiusOffset: -15,
  innerRadius: 2,
  padAngle: 7e-3,
  hoverArc: {
    outerRadiusOffset: 3
  },
  xOffset: 30,
  yOffset: 20,
  yOffsetCallout: 10,
  callout: {
    minSliceDegree: 5,
    offsetX: 15,
    offsetY: 12,
    horizontalLineLength: 8,
    textMargin: 2
  }
}, io = {
  opacity: {
    unselected: 0.1,
    selected: 0.3
  },
  xLabelPadding: 10,
  yLabelPadding: 8,
  yTicksNumber: 4,
  minRange: 10,
  xAxisRectHeight: 50,
  dotsRadius: 5
}, so = {
  nodeWidth: 4,
  nodeHoveredWidth: 8,
  minNodePadding: 24,
  opacity: {
    unfocus: 0.3,
    default: 0.8,
    selected: 1
  }
}, uo = {
  minCellDividerDimension: 16,
  // Ensures axes lines are displayed with or without stroke disabled
  chartPadding: 0.5
}, lo = {
  default: {
    size: 24
  }
}, co = {
  horizontalOffset: 10
}, fo = {
  default: {
    duration: 300
  },
  pie_slice_mouseover: {
    duration: 100
  },
  pie_chart_titles: {
    duration: 375
  },
  graph_element_mouseover_fill_update: {
    duration: 100
  },
  graph_element_mouseout_fill_update: {
    duration: 100
  }
}, ho = {
  buttonSize: 32,
  iconSize: 20,
  height: 32,
  spacerHeight: 10,
  iconPadding: 6
}, go = {
  height: {
    [mt.GRAPH_VIEW]: 32,
    [mt.SLIDER_VIEW]: 10
  },
  spacerHeight: 8,
  handleWidth: 5,
  handleBarWidth: 1,
  handleBarHeight: 12
}, Mn = [
  {
    type: K.RADIUS,
    name: "Radius"
  },
  {
    type: K.AREA,
    name: "Poor area"
  },
  {
    type: K.AREA,
    name: "Satisfactory area"
  },
  {
    type: K.AREA,
    name: "Great area"
  },
  {
    type: K.QUARTILE,
    name: "Quartiles"
  }
];
var mo = typeof global == "object" && global && global.Object === Object && global;
const $n = mo;
var po = typeof self == "object" && self && self.Object === Object && self, yo = $n || po || Function("return this")();
const ee = yo;
var vo = ee.Symbol;
const z = vo;
var An = Object.prototype, bo = An.hasOwnProperty, wo = An.toString, Ie = z ? z.toStringTag : void 0;
function To(e) {
  var t = bo.call(e, Ie), n = e[Ie];
  try {
    e[Ie] = void 0;
    var r = !0;
  } catch {
  }
  var a = wo.call(e);
  return r && (t ? e[Ie] = n : delete e[Ie]), a;
}
var So = Object.prototype, Oo = So.toString;
function Po(e) {
  return Oo.call(e);
}
var Eo = "[object Null]", _o = "[object Undefined]", zt = z ? z.toStringTag : void 0;
function ve(e) {
  return e == null ? e === void 0 ? _o : Eo : zt && zt in Object(e) ? To(e) : Po(e);
}
function J(e) {
  return e != null && typeof e == "object";
}
var Co = "[object Symbol]";
function Pt(e) {
  return typeof e == "symbol" || J(e) && ve(e) == Co;
}
function Mo(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = Array(r); ++n < r; )
    a[n] = t(e[n], n, e);
  return a;
}
var $o = Array.isArray;
const G = $o;
var Ao = 1 / 0, Qt = z ? z.prototype : void 0, kt = Qt ? Qt.toString : void 0;
function Dn(e) {
  if (typeof e == "string")
    return e;
  if (G(e))
    return Mo(e, Dn) + "";
  if (Pt(e))
    return kt ? kt.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Ao ? "-0" : t;
}
function ne(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function Et(e) {
  return e;
}
var Do = "[object AsyncFunction]", xo = "[object Function]", Lo = "[object GeneratorFunction]", Io = "[object Proxy]";
function _t(e) {
  if (!ne(e))
    return !1;
  var t = ve(e);
  return t == xo || t == Lo || t == Do || t == Io;
}
var Ro = ee["__core-js_shared__"];
const ft = Ro;
var Xt = function() {
  var e = /[^.]+$/.exec(ft && ft.keys && ft.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Fo(e) {
  return !!Xt && Xt in e;
}
var No = Function.prototype, Uo = No.toString;
function be(e) {
  if (e != null) {
    try {
      return Uo.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var jo = /[\\^$.*+?()[\]{}|]/g, Wo = /^\[object .+?Constructor\]$/, Ho = Function.prototype, Yo = Object.prototype, Bo = Ho.toString, Go = Yo.hasOwnProperty, qo = RegExp(
  "^" + Bo.call(Go).replace(jo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Vo(e) {
  if (!ne(e) || Fo(e))
    return !1;
  var t = _t(e) ? qo : Wo;
  return t.test(be(e));
}
function zo(e, t) {
  return e == null ? void 0 : e[t];
}
function we(e, t) {
  var n = zo(e, t);
  return Vo(n) ? n : void 0;
}
var Qo = we(ee, "WeakMap");
const yt = Qo;
var Kt = Object.create, ko = function() {
  function e() {
  }
  return function(t) {
    if (!ne(t))
      return {};
    if (Kt)
      return Kt(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
const Xo = ko;
function Ko(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function Jo() {
}
function xn(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var Zo = 800, ei = 16, ti = Date.now;
function ni(e) {
  var t = 0, n = 0;
  return function() {
    var r = ti(), a = ei - (r - n);
    if (n = r, a > 0) {
      if (++t >= Zo)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function ri(e) {
  return function() {
    return e;
  };
}
var ai = function() {
  try {
    var e = we(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Ze = ai;
var oi = Ze ? function(e, t) {
  return Ze(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ri(t),
    writable: !0
  });
} : Et;
const ii = oi;
var si = ni(ii);
const ui = si;
function li(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function ci(e, t, n, r) {
  for (var a = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < a; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function fi(e) {
  return e !== e;
}
function di(e, t, n) {
  for (var r = n - 1, a = e.length; ++r < a; )
    if (e[r] === t)
      return r;
  return -1;
}
function hi(e, t, n) {
  return t === t ? di(e, t, n) : ci(e, fi, n);
}
function gi(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && hi(e, t, 0) > -1;
}
var mi = 9007199254740991, pi = /^(?:0|[1-9]\d*)$/;
function Ct(e, t) {
  var n = typeof e;
  return t = t ?? mi, !!t && (n == "number" || n != "symbol" && pi.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Mt(e, t, n) {
  t == "__proto__" && Ze ? Ze(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function We(e, t) {
  return e === t || e !== e && t !== t;
}
var yi = Object.prototype, vi = yi.hasOwnProperty;
function Ln(e, t, n) {
  var r = e[t];
  (!(vi.call(e, t) && We(r, n)) || n === void 0 && !(t in e)) && Mt(e, t, n);
}
function He(e, t, n, r) {
  var a = !n;
  n || (n = {});
  for (var o = -1, i = t.length; ++o < i; ) {
    var u = t[o], l = r ? r(n[u], e[u], u, n, e) : void 0;
    l === void 0 && (l = e[u]), a ? Mt(n, u, l) : Ln(n, u, l);
  }
  return n;
}
var Jt = Math.max;
function bi(e, t, n) {
  return t = Jt(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, a = -1, o = Jt(r.length - t, 0), i = Array(o); ++a < o; )
      i[a] = r[t + a];
    a = -1;
    for (var u = Array(t + 1); ++a < t; )
      u[a] = r[a];
    return u[t] = n(i), Ko(e, this, u);
  };
}
function In(e, t) {
  return ui(bi(e, t, Et), e + "");
}
var wi = 9007199254740991;
function $t(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= wi;
}
function Ye(e) {
  return e != null && $t(e.length) && !_t(e);
}
function Ti(e, t, n) {
  if (!ne(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? Ye(n) && Ct(t, n.length) : r == "string" && t in n) ? We(n[t], e) : !1;
}
function Si(e) {
  return In(function(t, n) {
    var r = -1, a = n.length, o = a > 1 ? n[a - 1] : void 0, i = a > 2 ? n[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (a--, o) : void 0, i && Ti(n[0], n[1], i) && (o = a < 3 ? void 0 : o, a = 1), t = Object(t); ++r < a; ) {
      var u = n[r];
      u && e(t, u, r, o);
    }
    return t;
  });
}
var Oi = Object.prototype;
function rt(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Oi;
  return e === n;
}
function Pi(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Ei = "[object Arguments]";
function Zt(e) {
  return J(e) && ve(e) == Ei;
}
var Rn = Object.prototype, _i = Rn.hasOwnProperty, Ci = Rn.propertyIsEnumerable, Mi = Zt(function() {
  return arguments;
}()) ? Zt : function(e) {
  return J(e) && _i.call(e, "callee") && !Ci.call(e, "callee");
};
const _e = Mi;
function $i() {
  return !1;
}
var Fn = typeof exports == "object" && exports && !exports.nodeType && exports, en = Fn && typeof module == "object" && module && !module.nodeType && module, Ai = en && en.exports === Fn, tn = Ai ? ee.Buffer : void 0, Di = tn ? tn.isBuffer : void 0, xi = Di || $i;
const Ce = xi;
var Li = "[object Arguments]", Ii = "[object Array]", Ri = "[object Boolean]", Fi = "[object Date]", Ni = "[object Error]", Ui = "[object Function]", ji = "[object Map]", Wi = "[object Number]", Hi = "[object Object]", Yi = "[object RegExp]", Bi = "[object Set]", Gi = "[object String]", qi = "[object WeakMap]", Vi = "[object ArrayBuffer]", zi = "[object DataView]", Qi = "[object Float32Array]", ki = "[object Float64Array]", Xi = "[object Int8Array]", Ki = "[object Int16Array]", Ji = "[object Int32Array]", Zi = "[object Uint8Array]", es = "[object Uint8ClampedArray]", ts = "[object Uint16Array]", ns = "[object Uint32Array]", F = {};
F[Qi] = F[ki] = F[Xi] = F[Ki] = F[Ji] = F[Zi] = F[es] = F[ts] = F[ns] = !0;
F[Li] = F[Ii] = F[Vi] = F[Ri] = F[zi] = F[Fi] = F[Ni] = F[Ui] = F[ji] = F[Wi] = F[Hi] = F[Yi] = F[Bi] = F[Gi] = F[qi] = !1;
function rs(e) {
  return J(e) && $t(e.length) && !!F[ve(e)];
}
function At(e) {
  return function(t) {
    return e(t);
  };
}
var Nn = typeof exports == "object" && exports && !exports.nodeType && exports, Fe = Nn && typeof module == "object" && module && !module.nodeType && module, as = Fe && Fe.exports === Nn, dt = as && $n.process, os = function() {
  try {
    var e = Fe && Fe.require && Fe.require("util").types;
    return e || dt && dt.binding && dt.binding("util");
  } catch {
  }
}();
const Me = os;
var nn = Me && Me.isTypedArray, is = nn ? At(nn) : rs;
const at = is;
var ss = Object.prototype, us = ss.hasOwnProperty;
function Un(e, t) {
  var n = G(e), r = !n && _e(e), a = !n && !r && Ce(e), o = !n && !r && !a && at(e), i = n || r || a || o, u = i ? Pi(e.length, String) : [], l = u.length;
  for (var g in e)
    (t || us.call(e, g)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
    Ct(g, l))) && u.push(g);
  return u;
}
function jn(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var ls = jn(Object.keys, Object);
const cs = ls;
var fs = Object.prototype, ds = fs.hasOwnProperty;
function Wn(e) {
  if (!rt(e))
    return cs(e);
  var t = [];
  for (var n in Object(e))
    ds.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function ot(e) {
  return Ye(e) ? Un(e) : Wn(e);
}
function hs(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var gs = Object.prototype, ms = gs.hasOwnProperty;
function ps(e) {
  if (!ne(e))
    return hs(e);
  var t = rt(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !ms.call(e, r)) || n.push(r);
  return n;
}
function Be(e) {
  return Ye(e) ? Un(e, !0) : ps(e);
}
var ys = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, vs = /^\w*$/;
function Dt(e, t) {
  if (G(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Pt(e) ? !0 : vs.test(e) || !ys.test(e) || t != null && e in Object(t);
}
var bs = we(Object, "create");
const Ne = bs;
function ws() {
  this.__data__ = Ne ? Ne(null) : {}, this.size = 0;
}
function Ts(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ss = "__lodash_hash_undefined__", Os = Object.prototype, Ps = Os.hasOwnProperty;
function Es(e) {
  var t = this.__data__;
  if (Ne) {
    var n = t[e];
    return n === Ss ? void 0 : n;
  }
  return Ps.call(t, e) ? t[e] : void 0;
}
var _s = Object.prototype, Cs = _s.hasOwnProperty;
function Ms(e) {
  var t = this.__data__;
  return Ne ? t[e] !== void 0 : Cs.call(t, e);
}
var $s = "__lodash_hash_undefined__";
function As(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Ne && t === void 0 ? $s : t, this;
}
function pe(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
pe.prototype.clear = ws;
pe.prototype.delete = Ts;
pe.prototype.get = Es;
pe.prototype.has = Ms;
pe.prototype.set = As;
function Ds() {
  this.__data__ = [], this.size = 0;
}
function it(e, t) {
  for (var n = e.length; n--; )
    if (We(e[n][0], t))
      return n;
  return -1;
}
var xs = Array.prototype, Ls = xs.splice;
function Is(e) {
  var t = this.__data__, n = it(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Ls.call(t, n, 1), --this.size, !0;
}
function Rs(e) {
  var t = this.__data__, n = it(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Fs(e) {
  return it(this.__data__, e) > -1;
}
function Ns(e, t) {
  var n = this.__data__, r = it(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function re(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
re.prototype.clear = Ds;
re.prototype.delete = Is;
re.prototype.get = Rs;
re.prototype.has = Fs;
re.prototype.set = Ns;
var Us = we(ee, "Map");
const Ue = Us;
function js() {
  this.size = 0, this.__data__ = {
    hash: new pe(),
    map: new (Ue || re)(),
    string: new pe()
  };
}
function Ws(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function st(e, t) {
  var n = e.__data__;
  return Ws(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Hs(e) {
  var t = st(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Ys(e) {
  return st(this, e).get(e);
}
function Bs(e) {
  return st(this, e).has(e);
}
function Gs(e, t) {
  var n = st(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function ae(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ae.prototype.clear = js;
ae.prototype.delete = Hs;
ae.prototype.get = Ys;
ae.prototype.has = Bs;
ae.prototype.set = Gs;
var qs = "Expected a function";
function xt(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(qs);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(a))
      return o.get(a);
    var i = e.apply(this, r);
    return n.cache = o.set(a, i) || o, i;
  };
  return n.cache = new (xt.Cache || ae)(), n;
}
xt.Cache = ae;
var Vs = 500;
function zs(e) {
  var t = xt(e, function(r) {
    return n.size === Vs && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Qs = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ks = /\\(\\)?/g, Xs = zs(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Qs, function(n, r, a, o) {
    t.push(a ? o.replace(ks, "$1") : r || n);
  }), t;
});
const Ks = Xs;
function Js(e) {
  return e == null ? "" : Dn(e);
}
function Hn(e, t) {
  return G(e) ? e : Dt(e, t) ? [e] : Ks(Js(e));
}
var Zs = 1 / 0;
function ut(e) {
  if (typeof e == "string" || Pt(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Zs ? "-0" : t;
}
function Yn(e, t) {
  t = Hn(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[ut(t[n++])];
  return n && n == r ? e : void 0;
}
function eu(e, t, n) {
  var r = e == null ? void 0 : Yn(e, t);
  return r === void 0 ? n : r;
}
function Lt(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r; )
    e[a + n] = t[n];
  return e;
}
var rn = z ? z.isConcatSpreadable : void 0;
function tu(e) {
  return G(e) || _e(e) || !!(rn && e && e[rn]);
}
function Bn(e, t, n, r, a) {
  var o = -1, i = e.length;
  for (n || (n = tu), a || (a = []); ++o < i; ) {
    var u = e[o];
    t > 0 && n(u) ? t > 1 ? Bn(u, t - 1, n, r, a) : Lt(a, u) : r || (a[a.length] = u);
  }
  return a;
}
var nu = jn(Object.getPrototypeOf, Object);
const It = nu;
var ru = "[object Object]", au = Function.prototype, ou = Object.prototype, Gn = au.toString, iu = ou.hasOwnProperty, su = Gn.call(Object);
function uu(e) {
  if (!J(e) || ve(e) != ru)
    return !1;
  var t = It(e);
  if (t === null)
    return !0;
  var n = iu.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Gn.call(n) == su;
}
function lu() {
  this.__data__ = new re(), this.size = 0;
}
function cu(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function fu(e) {
  return this.__data__.get(e);
}
function du(e) {
  return this.__data__.has(e);
}
var hu = 200;
function gu(e, t) {
  var n = this.__data__;
  if (n instanceof re) {
    var r = n.__data__;
    if (!Ue || r.length < hu - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new ae(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function k(e) {
  var t = this.__data__ = new re(e);
  this.size = t.size;
}
k.prototype.clear = lu;
k.prototype.delete = cu;
k.prototype.get = fu;
k.prototype.has = du;
k.prototype.set = gu;
function mu(e, t) {
  return e && He(t, ot(t), e);
}
function pu(e, t) {
  return e && He(t, Be(t), e);
}
var qn = typeof exports == "object" && exports && !exports.nodeType && exports, an = qn && typeof module == "object" && module && !module.nodeType && module, yu = an && an.exports === qn, on = yu ? ee.Buffer : void 0, sn = on ? on.allocUnsafe : void 0;
function Vn(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = sn ? sn(n) : new e.constructor(n);
  return e.copy(r), r;
}
function vu(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, o = []; ++n < r; ) {
    var i = e[n];
    t(i, n, e) && (o[a++] = i);
  }
  return o;
}
function zn() {
  return [];
}
var bu = Object.prototype, wu = bu.propertyIsEnumerable, un = Object.getOwnPropertySymbols, Tu = un ? function(e) {
  return e == null ? [] : (e = Object(e), vu(un(e), function(t) {
    return wu.call(e, t);
  }));
} : zn;
const Rt = Tu;
function Su(e, t) {
  return He(e, Rt(e), t);
}
var Ou = Object.getOwnPropertySymbols, Pu = Ou ? function(e) {
  for (var t = []; e; )
    Lt(t, Rt(e)), e = It(e);
  return t;
} : zn;
const Qn = Pu;
function Eu(e, t) {
  return He(e, Qn(e), t);
}
function kn(e, t, n) {
  var r = t(e);
  return G(e) ? r : Lt(r, n(e));
}
function vt(e) {
  return kn(e, ot, Rt);
}
function _u(e) {
  return kn(e, Be, Qn);
}
var Cu = we(ee, "DataView");
const bt = Cu;
var Mu = we(ee, "Promise");
const wt = Mu;
var $u = we(ee, "Set");
const Ee = $u;
var ln = "[object Map]", Au = "[object Object]", cn = "[object Promise]", fn = "[object Set]", dn = "[object WeakMap]", hn = "[object DataView]", Du = be(bt), xu = be(Ue), Lu = be(wt), Iu = be(Ee), Ru = be(yt), he = ve;
(bt && he(new bt(new ArrayBuffer(1))) != hn || Ue && he(new Ue()) != ln || wt && he(wt.resolve()) != cn || Ee && he(new Ee()) != fn || yt && he(new yt()) != dn) && (he = function(e) {
  var t = ve(e), n = t == Au ? e.constructor : void 0, r = n ? be(n) : "";
  if (r)
    switch (r) {
      case Du:
        return hn;
      case xu:
        return ln;
      case Lu:
        return cn;
      case Iu:
        return fn;
      case Ru:
        return dn;
    }
  return t;
});
const $e = he;
var Fu = Object.prototype, Nu = Fu.hasOwnProperty;
function Uu(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Nu.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var ju = ee.Uint8Array;
const et = ju;
function Ft(e) {
  var t = new e.constructor(e.byteLength);
  return new et(t).set(new et(e)), t;
}
function Wu(e, t) {
  var n = t ? Ft(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Hu = /\w*$/;
function Yu(e) {
  var t = new e.constructor(e.source, Hu.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var gn = z ? z.prototype : void 0, mn = gn ? gn.valueOf : void 0;
function Bu(e) {
  return mn ? Object(mn.call(e)) : {};
}
function Xn(e, t) {
  var n = t ? Ft(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Gu = "[object Boolean]", qu = "[object Date]", Vu = "[object Map]", zu = "[object Number]", Qu = "[object RegExp]", ku = "[object Set]", Xu = "[object String]", Ku = "[object Symbol]", Ju = "[object ArrayBuffer]", Zu = "[object DataView]", el = "[object Float32Array]", tl = "[object Float64Array]", nl = "[object Int8Array]", rl = "[object Int16Array]", al = "[object Int32Array]", ol = "[object Uint8Array]", il = "[object Uint8ClampedArray]", sl = "[object Uint16Array]", ul = "[object Uint32Array]";
function ll(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case Ju:
      return Ft(e);
    case Gu:
    case qu:
      return new r(+e);
    case Zu:
      return Wu(e, n);
    case el:
    case tl:
    case nl:
    case rl:
    case al:
    case ol:
    case il:
    case sl:
    case ul:
      return Xn(e, n);
    case Vu:
      return new r();
    case zu:
    case Xu:
      return new r(e);
    case Qu:
      return Yu(e);
    case ku:
      return new r();
    case Ku:
      return Bu(e);
  }
}
function Kn(e) {
  return typeof e.constructor == "function" && !rt(e) ? Xo(It(e)) : {};
}
var cl = "[object Map]";
function fl(e) {
  return J(e) && $e(e) == cl;
}
var pn = Me && Me.isMap, dl = pn ? At(pn) : fl;
const hl = dl;
var gl = "[object Set]";
function ml(e) {
  return J(e) && $e(e) == gl;
}
var yn = Me && Me.isSet, pl = yn ? At(yn) : ml;
const yl = pl;
var vl = 1, bl = 2, wl = 4, Jn = "[object Arguments]", Tl = "[object Array]", Sl = "[object Boolean]", Ol = "[object Date]", Pl = "[object Error]", Zn = "[object Function]", El = "[object GeneratorFunction]", _l = "[object Map]", Cl = "[object Number]", er = "[object Object]", Ml = "[object RegExp]", $l = "[object Set]", Al = "[object String]", Dl = "[object Symbol]", xl = "[object WeakMap]", Ll = "[object ArrayBuffer]", Il = "[object DataView]", Rl = "[object Float32Array]", Fl = "[object Float64Array]", Nl = "[object Int8Array]", Ul = "[object Int16Array]", jl = "[object Int32Array]", Wl = "[object Uint8Array]", Hl = "[object Uint8ClampedArray]", Yl = "[object Uint16Array]", Bl = "[object Uint32Array]", L = {};
L[Jn] = L[Tl] = L[Ll] = L[Il] = L[Sl] = L[Ol] = L[Rl] = L[Fl] = L[Nl] = L[Ul] = L[jl] = L[_l] = L[Cl] = L[er] = L[Ml] = L[$l] = L[Al] = L[Dl] = L[Wl] = L[Hl] = L[Yl] = L[Bl] = !0;
L[Pl] = L[Zn] = L[xl] = !1;
function ke(e, t, n, r, a, o) {
  var i, u = t & vl, l = t & bl, g = t & wl;
  if (n && (i = a ? n(e, r, a, o) : n(e)), i !== void 0)
    return i;
  if (!ne(e))
    return e;
  var f = G(e);
  if (f) {
    if (i = Uu(e), !u)
      return xn(e, i);
  } else {
    var m = $e(e), v = m == Zn || m == El;
    if (Ce(e))
      return Vn(e, u);
    if (m == er || m == Jn || v && !a) {
      if (i = l || v ? {} : Kn(e), !u)
        return l ? Eu(e, pu(i, e)) : Su(e, mu(i, e));
    } else {
      if (!L[m])
        return a ? e : {};
      i = ll(e, m, u);
    }
  }
  o || (o = new k());
  var C = o.get(e);
  if (C)
    return C;
  o.set(e, i), yl(e) ? e.forEach(function(P) {
    i.add(ke(P, t, n, P, e, o));
  }) : hl(e) && e.forEach(function(P, U) {
    i.set(U, ke(P, t, n, U, e, o));
  });
  var M = g ? l ? _u : vt : l ? Be : ot, x = f ? void 0 : M(e);
  return li(x || e, function(P, U) {
    x && (U = P, P = e[U]), Ln(i, U, ke(P, t, n, U, e, o));
  }), i;
}
var Gl = 1, ql = 4;
function Vl(e) {
  return ke(e, Gl | ql);
}
var zl = "__lodash_hash_undefined__";
function Ql(e) {
  return this.__data__.set(e, zl), this;
}
function kl(e) {
  return this.__data__.has(e);
}
function je(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new ae(); ++t < n; )
    this.add(e[t]);
}
je.prototype.add = je.prototype.push = Ql;
je.prototype.has = kl;
function Xl(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function tr(e, t) {
  return e.has(t);
}
var Kl = 1, Jl = 2;
function nr(e, t, n, r, a, o) {
  var i = n & Kl, u = e.length, l = t.length;
  if (u != l && !(i && l > u))
    return !1;
  var g = o.get(e), f = o.get(t);
  if (g && f)
    return g == t && f == e;
  var m = -1, v = !0, C = n & Jl ? new je() : void 0;
  for (o.set(e, t), o.set(t, e); ++m < u; ) {
    var M = e[m], x = t[m];
    if (r)
      var P = i ? r(x, M, m, t, e, o) : r(M, x, m, e, t, o);
    if (P !== void 0) {
      if (P)
        continue;
      v = !1;
      break;
    }
    if (C) {
      if (!Xl(t, function(U, q) {
        if (!tr(C, q) && (M === U || a(M, U, n, r, o)))
          return C.push(q);
      })) {
        v = !1;
        break;
      }
    } else if (!(M === x || a(M, x, n, r, o))) {
      v = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), v;
}
function Zl(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, a) {
    n[++t] = [a, r];
  }), n;
}
function Nt(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var ec = 1, tc = 2, nc = "[object Boolean]", rc = "[object Date]", ac = "[object Error]", oc = "[object Map]", ic = "[object Number]", sc = "[object RegExp]", uc = "[object Set]", lc = "[object String]", cc = "[object Symbol]", fc = "[object ArrayBuffer]", dc = "[object DataView]", vn = z ? z.prototype : void 0, ht = vn ? vn.valueOf : void 0;
function hc(e, t, n, r, a, o, i) {
  switch (n) {
    case dc:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case fc:
      return !(e.byteLength != t.byteLength || !o(new et(e), new et(t)));
    case nc:
    case rc:
    case ic:
      return We(+e, +t);
    case ac:
      return e.name == t.name && e.message == t.message;
    case sc:
    case lc:
      return e == t + "";
    case oc:
      var u = Zl;
    case uc:
      var l = r & ec;
      if (u || (u = Nt), e.size != t.size && !l)
        return !1;
      var g = i.get(e);
      if (g)
        return g == t;
      r |= tc, i.set(e, t);
      var f = nr(u(e), u(t), r, a, o, i);
      return i.delete(e), f;
    case cc:
      if (ht)
        return ht.call(e) == ht.call(t);
  }
  return !1;
}
var gc = 1, mc = Object.prototype, pc = mc.hasOwnProperty;
function yc(e, t, n, r, a, o) {
  var i = n & gc, u = vt(e), l = u.length, g = vt(t), f = g.length;
  if (l != f && !i)
    return !1;
  for (var m = l; m--; ) {
    var v = u[m];
    if (!(i ? v in t : pc.call(t, v)))
      return !1;
  }
  var C = o.get(e), M = o.get(t);
  if (C && M)
    return C == t && M == e;
  var x = !0;
  o.set(e, t), o.set(t, e);
  for (var P = i; ++m < l; ) {
    v = u[m];
    var U = e[v], q = t[v];
    if (r)
      var oe = i ? r(q, U, v, t, e, o) : r(U, q, v, e, t, o);
    if (!(oe === void 0 ? U === q || a(U, q, n, r, o) : oe)) {
      x = !1;
      break;
    }
    P || (P = v == "constructor");
  }
  if (x && !P) {
    var V = e.constructor, Q = t.constructor;
    V != Q && "constructor" in e && "constructor" in t && !(typeof V == "function" && V instanceof V && typeof Q == "function" && Q instanceof Q) && (x = !1);
  }
  return o.delete(e), o.delete(t), x;
}
var vc = 1, bn = "[object Arguments]", wn = "[object Array]", Ve = "[object Object]", bc = Object.prototype, Tn = bc.hasOwnProperty;
function wc(e, t, n, r, a, o) {
  var i = G(e), u = G(t), l = i ? wn : $e(e), g = u ? wn : $e(t);
  l = l == bn ? Ve : l, g = g == bn ? Ve : g;
  var f = l == Ve, m = g == Ve, v = l == g;
  if (v && Ce(e)) {
    if (!Ce(t))
      return !1;
    i = !0, f = !1;
  }
  if (v && !f)
    return o || (o = new k()), i || at(e) ? nr(e, t, n, r, a, o) : hc(e, t, l, n, r, a, o);
  if (!(n & vc)) {
    var C = f && Tn.call(e, "__wrapped__"), M = m && Tn.call(t, "__wrapped__");
    if (C || M) {
      var x = C ? e.value() : e, P = M ? t.value() : t;
      return o || (o = new k()), a(x, P, n, r, o);
    }
  }
  return v ? (o || (o = new k()), yc(e, t, n, r, a, o)) : !1;
}
function Ut(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !J(e) && !J(t) ? e !== e && t !== t : wc(e, t, n, r, Ut, a);
}
var Tc = 1, Sc = 2;
function Oc(e, t, n, r) {
  var a = n.length, o = a, i = !r;
  if (e == null)
    return !o;
  for (e = Object(e); a--; ) {
    var u = n[a];
    if (i && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++a < o; ) {
    u = n[a];
    var l = u[0], g = e[l], f = u[1];
    if (i && u[2]) {
      if (g === void 0 && !(l in e))
        return !1;
    } else {
      var m = new k();
      if (r)
        var v = r(g, f, l, e, t, m);
      if (!(v === void 0 ? Ut(f, g, Tc | Sc, r, m) : v))
        return !1;
    }
  }
  return !0;
}
function rr(e) {
  return e === e && !ne(e);
}
function Pc(e) {
  for (var t = ot(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, rr(a)];
  }
  return t;
}
function ar(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function Ec(e) {
  var t = Pc(e);
  return t.length == 1 && t[0][2] ? ar(t[0][0], t[0][1]) : function(n) {
    return n === e || Oc(n, e, t);
  };
}
function _c(e, t) {
  return e != null && t in Object(e);
}
function Cc(e, t, n) {
  t = Hn(t, e);
  for (var r = -1, a = t.length, o = !1; ++r < a; ) {
    var i = ut(t[r]);
    if (!(o = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return o || ++r != a ? o : (a = e == null ? 0 : e.length, !!a && $t(a) && Ct(i, a) && (G(e) || _e(e)));
}
function Mc(e, t) {
  return e != null && Cc(e, t, _c);
}
var $c = 1, Ac = 2;
function Dc(e, t) {
  return Dt(e) && rr(t) ? ar(ut(e), t) : function(n) {
    var r = eu(n, e);
    return r === void 0 && r === t ? Mc(n, e) : Ut(t, r, $c | Ac);
  };
}
function xc(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Lc(e) {
  return function(t) {
    return Yn(t, e);
  };
}
function Ic(e) {
  return Dt(e) ? xc(ut(e)) : Lc(e);
}
function Rc(e) {
  return typeof e == "function" ? e : e == null ? Et : typeof e == "object" ? G(e) ? Dc(e[0], e[1]) : Ec(e) : Ic(e);
}
function Fc(e) {
  return function(t, n, r) {
    for (var a = -1, o = Object(t), i = r(t), u = i.length; u--; ) {
      var l = i[e ? u : ++a];
      if (n(o[l], l, o) === !1)
        break;
    }
    return t;
  };
}
var Nc = Fc();
const Uc = Nc;
function Tt(e, t, n) {
  (n !== void 0 && !We(e[t], n) || n === void 0 && !(t in e)) && Mt(e, t, n);
}
function St(e) {
  return J(e) && Ye(e);
}
function Ot(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function jc(e) {
  return He(e, Be(e));
}
function Wc(e, t, n, r, a, o, i) {
  var u = Ot(e, n), l = Ot(t, n), g = i.get(l);
  if (g) {
    Tt(e, n, g);
    return;
  }
  var f = o ? o(u, l, n + "", e, t, i) : void 0, m = f === void 0;
  if (m) {
    var v = G(l), C = !v && Ce(l), M = !v && !C && at(l);
    f = l, v || C || M ? G(u) ? f = u : St(u) ? f = xn(u) : C ? (m = !1, f = Vn(l, !0)) : M ? (m = !1, f = Xn(l, !0)) : f = [] : uu(l) || _e(l) ? (f = u, _e(u) ? f = jc(u) : (!ne(u) || _t(u)) && (f = Kn(l))) : m = !1;
  }
  m && (i.set(l, f), a(f, l, r, o, i), i.delete(l)), Tt(e, n, f);
}
function or(e, t, n, r, a) {
  e !== t && Uc(t, function(o, i) {
    if (a || (a = new k()), ne(o))
      Wc(e, t, i, n, or, r, a);
    else {
      var u = r ? r(Ot(e, i), o, i + "", e, t, a) : void 0;
      u === void 0 && (u = o), Tt(e, i, u);
    }
  }, Be);
}
function Hc(e, t, n) {
  for (var r = -1, a = e == null ? 0 : e.length; ++r < a; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
function Yc(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Bc = "[object Map]", Gc = "[object Set]", qc = Object.prototype, Vc = qc.hasOwnProperty;
function zc(e) {
  if (e == null)
    return !0;
  if (Ye(e) && (G(e) || typeof e == "string" || typeof e.splice == "function" || Ce(e) || at(e) || _e(e)))
    return !e.length;
  var t = $e(e);
  if (t == Bc || t == Gc)
    return !e.size;
  if (rt(e))
    return !Wn(e).length;
  for (var n in e)
    if (Vc.call(e, n))
      return !1;
  return !0;
}
var Qc = Si(function(e, t, n) {
  or(e, t, n);
});
const _ = Qc;
var kc = 1 / 0, Xc = Ee && 1 / Nt(new Ee([, -0]))[1] == kc ? function(e) {
  return new Ee(e);
} : Jo;
const Kc = Xc;
var Jc = 200;
function ir(e, t, n) {
  var r = -1, a = gi, o = e.length, i = !0, u = [], l = u;
  if (n)
    i = !1, a = Hc;
  else if (o >= Jc) {
    var g = t ? null : Kc(e);
    if (g)
      return Nt(g);
    i = !1, a = tr, l = new je();
  } else
    l = t ? [] : u;
  e:
    for (; ++r < o; ) {
      var f = e[r], m = t ? t(f) : f;
      if (f = n || f !== 0 ? f : 0, i && m === m) {
        for (var v = l.length; v--; )
          if (l[v] === m)
            continue e;
        t && l.push(m), u.push(f);
      } else
        a(l, m, n) || (l !== u && l.push(m), u.push(f));
    }
  return u;
}
var Zc = In(function(e) {
  var t = Yc(e);
  return St(t) && (t = void 0), ir(Bn(e, 1, St, !0), Rc(t));
});
const ef = Zc;
function tf(e) {
  return e && e.length ? ir(e) : [];
}
const nf = Vl, Hf = tf;
function Yf(e, t, n) {
  let r = null;
  return (...a) => {
    const o = this;
    o.mousePosition = _r(a[0], n), clearTimeout(r), r = setTimeout(function() {
      e.apply(o, a);
    }, t);
  };
}
function Bf(e, t) {
  var a;
  const n = nf(e), r = Object.keys(t.axes || {});
  (a = t == null ? void 0 : t.toolbar) != null && a.controls && delete n.toolbar.controls, r.length === 0 && delete n.axes;
  for (const o in n.axes)
    if (r.includes(o)) {
      const i = t.axes[o];
      (i.primary || i.secondary) && console.warn(
        "`primary` & `secondary` are no longer needed for axis configurations. Read more here https://carbon-design-system.github.io/carbon-charts/?path=/story/docs-tutorials--tabular-data-format"
      );
      const u = i.mapsTo;
      if (u == null) {
        const l = i.scaleType;
        l == null ? i.mapsTo = "value" : l === Yt.TIME ? i.mapsTo = "date" : l === Yt.LABELS && (i.mapsTo = "key");
      }
    } else
      delete n.axes[o];
  return rf(n, t), _(n, t);
}
function Gf(e) {
  if (!e)
    return;
  const t = /translate\([0-9]+\.?[0-9]*,[0-9]+\.?[0-9]*\)/, n = e.getAttribute("transform").match(t);
  if (!n)
    return null;
  if (n[0]) {
    const r = n[0].replace(/translate\(/, "").replace(/\)/, "").split(",");
    return {
      tx: r[0],
      ty: r[1]
    };
  }
  return null;
}
function qf(e) {
  const n = /\(([^)]+)\)/.exec(e);
  if (n && n.length > 1) {
    const r = n[1].split(",");
    if (r.length > 1)
      return {
        x: parseFloat(r[0]),
        y: parseFloat(r[1])
      };
  }
  return { x: 0, y: 0 };
}
function Vf(e, t, n = "value") {
  const r = e / t.reduce((a, o) => a + o[n], 0) * 100;
  return r % 1 !== 0 ? parseFloat(r.toFixed(1)) : r;
}
function zf(e, t, n) {
  if (n > e.length)
    return e;
  if (t === Qe.MID_LINE)
    return e.substr(0, n / 2) + "..." + e.substr(-n / 2);
  if (t === Qe.FRONT_LINE)
    return "..." + e.substr(-n);
  if (t === Qe.END_LINE)
    return e.substr(0, n) + "...";
}
function rf(e, t) {
  const n = ge(e, "legend", "additionalItems"), r = ge(t, "legend", "additionalItems");
  if (n && r) {
    const a = r.map((u) => u.type), o = n.map((u) => u.type), i = Mn.filter(
      (u) => o.includes(u.type) && !a.includes(u.type)
    );
    e.legend.additionalItems = i, t.legend.additionalItems = ef(
      i,
      r,
      "name"
    );
  }
}
const ge = (e, ...t) => {
  let n = e;
  if (n) {
    for (const r of t)
      if (n[r] !== null && n[r] !== void 0)
        n = n[r];
      else
        return null;
    return n;
  }
  return null;
}, af = (e, t) => t === Sn.HORIZONTAL ? {
  y0: e.x0,
  y1: e.x1,
  x0: e.y0,
  x1: e.y1
} : e, Qf = (e, t) => {
  const { x0: n, x1: r, y0: a, y1: o } = af(e, t);
  return `M${n},${a}L${n},${o}L${r},${o}L${r},${a}L${n},${a}`;
};
function kf(e, t, n) {
  return n === Sn.VERTICAL ? [e, t] : [t, e];
}
const Pe = {
  type: Qe.END_LINE,
  threshold: 16,
  numCharacter: 14
}, of = {
  enabled: !0,
  position: Dr.BOTTOM,
  clickable: !0,
  truncation: Pe,
  alignment: Ae.LEFT,
  order: null,
  additionalItems: []
}, sr = {
  x: {
    // set enable to false will not draw grid and stroke of grid backdrop
    enabled: !0,
    numberOfTicks: 15,
    alignWithAxisTicks: !1
  },
  y: {
    // set enable to false will not draw grid and stroke of grid backdrop
    enabled: !0,
    numberOfTicks: 5,
    alignWithAxisTicks: !1
  }
}, ur = {
  // enable or disable ruler
  enabled: !0
}, jt = {
  enabled: !0,
  showTotal: !0,
  truncation: Pe,
  groupLabel: "Group"
}, lr = {
  top: {
    visible: !0,
    includeZero: !0,
    truncation: Pe
  },
  bottom: {
    visible: !0,
    includeZero: !0,
    truncation: Pe
  },
  left: {
    visible: !0,
    includeZero: !0,
    truncation: Pe
  },
  right: {
    visible: !0,
    includeZero: !0,
    truncation: Pe
  }
}, Ge = {
  addSpaceOnEdges: 1,
  showDayName: !1,
  localeObject: _n,
  timeIntervalFormats: {
    "15seconds": { primary: "MMM d, pp", secondary: "pp" },
    minute: { primary: "MMM d, p", secondary: "p" },
    "30minutes": { primary: "MMM d, p", secondary: "p" },
    hourly: { primary: "MMM d, hh a", secondary: "hh a" },
    daily: { primary: "MMM d", secondary: "d" },
    weekly: { primary: "eee, MMM d", secondary: "eee" },
    monthly: { primary: "MMM yyyy", secondary: "MMM" },
    quarterly: { primary: "QQQ ''yy", secondary: "QQQ" },
    yearly: { primary: "yyyy", secondary: "yyyy" }
  }
}, sf = typeof document < "u" && (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled), Y = {
  width: null,
  height: null,
  resizable: !0,
  theme: xr.WHITE,
  tooltip: jt,
  legend: of,
  style: {
    prefix: "cc"
  },
  data: {
    groupMapsTo: "group",
    loading: !1,
    selectedGroups: []
  },
  color: {
    scale: null,
    pairing: {
      numberOfVariants: null,
      option: 1
    },
    gradient: {
      enabled: !1
    }
  },
  toolbar: {
    enabled: !0,
    numberOfIcons: 3,
    controls: [
      {
        type: De.SHOW_AS_DATATABLE
      },
      ...sf ? [
        {
          type: De.MAKE_FULLSCREEN
        }
      ] : [],
      {
        type: De.EXPORT_CSV
      },
      {
        type: De.EXPORT_PNG
      },
      {
        type: De.EXPORT_JPG
      }
    ]
  }
}, cr = _({}, Y, {
  thematic: {
    projection: Lr.geoNaturalEarth1
  }
}), qe = _({}, Y, {
  axes: lr,
  timeScale: Ge,
  grid: sr,
  ruler: ur,
  zoomBar: {
    zoomRatio: 0.4,
    minZoomRatio: 0.01,
    top: {
      enabled: !1,
      type: mt.GRAPH_VIEW
    }
  }
}), ye = _({}, qe, {
  bars: {
    maxWidth: 16,
    spacingFactor: 0.25
  },
  timeScale: _(Ge, {
    addSpaceOnEdges: 1
  })
}), uf = _({}, ye, {}), lf = _({}, ye, {}), cf = _({}, ye, {
  bars: _({}, ye.bars, {
    dividerSize: 1.5
  })
}), ff = _({}, ye, {}), Wt = _({}, qe, {
  points: {
    // default point radius to 4
    radius: 4,
    fillOpacity: 0.3,
    filled: !0,
    enabled: !0
  }
}), df = Wt, fr = _({}, Wt, {
  points: {
    // default point radius to 3
    radius: 3,
    filled: !1,
    enabled: !0
  }
}), dr = _({}, fr, {
  timeScale: _(Ge, {
    addSpaceOnEdges: 0
  })
}), hf = dr, gf = _({}, qe, {
  bubble: {
    radiusMapsTo: "radius",
    radiusLabel: "Radius",
    radiusRange: (e) => {
      const t = Math.min(e.width, e.height);
      return [t * 3 / 400, t * 25 / 400];
    },
    fillOpacity: 0.2,
    enabled: !0
  },
  points: {
    filled: !0
  },
  legend: {
    additionalItems: [
      {
        type: K.RADIUS,
        name: "Radius"
      }
    ]
  }
}), mf = _({}, qe, {
  bullet: {
    performanceAreaTitles: ["Poor", "Satisfactory", "Great"]
  },
  grid: {
    x: {
      enabled: !1
    },
    y: {
      enabled: !1
    }
  },
  legend: {
    additionalItems: [
      {
        type: K.AREA,
        name: "Poor area"
      },
      {
        type: K.AREA,
        name: "Satisfactory area"
      },
      {
        type: K.AREA,
        name: "Great area"
      },
      {
        type: K.QUARTILE,
        name: "Quartiles"
      }
    ]
  }
}), pf = _({}, ye, {
  bars: {
    dividerSize: 1.5
  },
  timeScale: _(Ge, {
    addSpaceOnEdges: 0
  })
}), yf = _({}, Y, {
  tooltip: _({}, jt, {
    wordLabel: "Word",
    valueLabel: "Value"
  }),
  wordCloud: {
    fontSizeMapsTo: "value",
    fontSizeRange: (e) => {
      const t = Math.min(e.width, e.height);
      return [t * 20 / 400, t * 75 / 400];
    },
    wordMapsTo: "word"
  }
}), hr = _({}, Y, {
  pie: {
    labels: {
      formatter: null,
      enabled: !0
    },
    alignment: Ae.LEFT,
    sortFunction: null,
    valueMapsTo: "value"
  }
}), vf = _({}, Y, {
  legend: {
    enabled: !1
  },
  gauge: {
    type: Ir.SEMI,
    arcWidth: 16,
    deltaArrow: {
      size: (e) => e / 8,
      enabled: !0
    },
    showPercentageSymbol: !0,
    status: null,
    numberSpacing: 10,
    deltaFontSize: (e) => e / 8,
    valueFontSize: (e) => e / 2.5,
    numberFormatter: (e) => Number(e.toFixed(2)) % 1 !== 0 ? e.toFixed(2).toLocaleString() : e.toFixed().toLocaleString(),
    alignment: Ae.LEFT
  }
}), bf = _({}, hr, {
  donut: {
    center: {
      numberFontSize: (e) => `${Math.min(e / 100 * 24, 24)}px`,
      titleFontSize: (e) => `${Math.min(e / 100 * 15, 15)}px`,
      titleYPosition: (e) => Math.min(e / 80 * 20, 20),
      numberFormatter: (e) => Math.floor(e).toLocaleString()
    },
    alignment: Ae.LEFT
  }
}), gr = _({}, Y, {
  legend: {
    enabled: !1,
    clickable: !1
  },
  meter: {
    showLabels: !0,
    proportional: null,
    statusBar: {
      percentageIndicator: {
        enabled: !0
      }
    }
  }
}), wf = _({}, gr, {
  legend: {
    enabled: !0
  }
}), Tf = _({}, Y, {
  radar: {
    axes: {
      angle: "key",
      value: "value"
    },
    alignment: Ae.LEFT
  },
  tooltip: {
    gridline: {
      enabled: !0
    },
    valueFormatter: (e) => e ?? "N/A"
  }
}), Sf = _({}, ye, {
  comboChartTypes: []
}), Of = _(
  {
    tree: {
      type: Rr.TREE
    }
  },
  Y,
  {}
), Pf = _({}, Y, {
  data: _(Y.data, {
    groupMapsTo: "name"
  })
}), Ef = _({}, Y, Cn, {
  data: _(Y.data, {
    groupMapsTo: "name"
  })
}), _f = _({}, Y, {
  alluvial: {
    data: _(Y.data, {
      groupMapsTo: "source"
    }),
    nodeAlignment: Ae.CENTER,
    nodePadding: 24,
    monochrome: !1,
    nodes: []
  }
}), Cf = _({}, Y, {
  axes: lr,
  heatmap: {
    divider: {
      state: Fr.AUTO
    },
    colorLegend: {
      type: "linear"
    }
  }
}), Mf = _({}, cr, {
  choropleth: {
    colorLegend: {
      type: "linear"
    }
  }
}), $f = {
  alluvialChart: _f,
  areaChart: dr,
  axisChart: qe,
  boxplotChart: ff,
  bubbleChart: gf,
  bulletChart: mf,
  chart: Y,
  circlePackChart: Ef,
  choroplethChart: Mf,
  comboChart: Sf,
  donutChart: bf,
  gaugeChart: vf,
  groupedBarChart: lf,
  heatmapChart: Cf,
  histogramChart: pf,
  lineChart: fr,
  lollipopChart: df,
  meterChart: gr,
  pieChart: hr,
  proportionalMeterChart: wf,
  radarChart: Tf,
  scatterChart: Wt,
  simpleBarChart: uf,
  stackedAreaChart: hf,
  stackedBarChart: cf,
  thematicChart: cr,
  treeChart: Of,
  treemapChart: Pf,
  wordCloudChart: yf
}, Xf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alluvial: so,
  area: Xa,
  axis: Ka,
  baseTooltip: jt,
  boxplot: eo,
  canvasZoomSettings: Ja,
  carbonPrefix: ka,
  circlePack: Cn,
  color: Za,
  defaultLegendAdditionalItems: Mn,
  grid: sr,
  heatmap: uo,
  histogram: to,
  legend: no,
  lines: ro,
  meter: ao,
  options: $f,
  pie: oo,
  radar: io,
  ruler: ur,
  spacers: lo,
  timeScale: Ge,
  toolbar: ho,
  tooltips: co,
  transitions: fo,
  zoomBar: go
}, Symbol.toStringTag, { value: "Module" }));
var mr = /* @__PURE__ */ ((e) => (e["15seconds"] = "15seconds", e.minute = "minute", e["30minutes"] = "30minutes", e.hourly = "hourly", e.daily = "daily", e.weekly = "weekly", e.monthly = "monthly", e.quarterly = "quarterly", e.yearly = "yearly", e))(mr || {});
const gt = [
  ["15seconds", 15 * 1e3],
  ["minute", 60 * 1e3],
  ["30minutes", 30 * 60 * 1e3],
  ["hourly", 60 * 60 * 1e3],
  ["daily", 24 * 60 * 60 * 1e3],
  ["monthly", 30 * 24 * 60 * 60 * 1e3],
  ["quarterly", 3 * 30 * 24 * 60 * 60 * 1e3],
  ["yearly", 12 * 30 * 24 * 60 * 60 * 1e3]
];
function Af(e, t, n, r, a) {
  const o = t === 0, i = Number(pt(new Date(e), "c")) === 2, u = Number(pt(new Date(e), "q")) === 1, l = t !== 0 ? n[t - 1] : null;
  switch (r) {
    case "15seconds":
      return o || ze(e) || Re(e, l) || ue(e);
    case "minute":
      return o || ze(e) || Re(e, l) || ue(e);
    case "30minutes":
      return o || ze(e) || Re(e, l) || ue(e);
    case "hourly":
      return o || ze(e) || Re(e, l) || ue(e);
    case "daily":
      return a ? o || i || ue(e) : o || Re(e, l) || ue(e);
    case "weekly":
      return o || i || ue(e);
    case "monthly":
      return o || ue(e);
    case "quarterly":
      return o || u;
    case "yearly":
      return !1;
    default:
      throw new Error(`${r} is not a valid time interval.`);
  }
}
function Kf(e, t, n, r, a) {
  const o = a.showDayName, i = r === "daily" && o ? "weekly" : r, u = new Date(e), l = ge(a, "timeIntervalFormats")[i], g = ge(l, "primary"), f = ge(l, "secondary");
  let m = Af(e, t, n, r, o) ? g : f;
  r === "15seconds" && u.getMilliseconds() !== 0 && (m = m.replace("pp", "h:mm:ss.SSS a"));
  const v = a.localeObject;
  return pt(u, m, { locale: v });
}
function tt(e) {
  const t = new Date(e);
  return {
    M: t.getMonth() + 1,
    // month: 1-12
    d: t.getDate(),
    // day of the month: 1-31
    H: t.getHours(),
    // 24-hour clock: 0-23
    m: t.getMinutes(),
    // minute: 0-59
    s: t.getSeconds()
    // seconds: 0-59
  };
}
function Df(e) {
  if (e)
    return e.slice(1).map((t, n) => t - e[n]);
}
function xf(e) {
  const t = gt.reduce((n, [, r], a) => {
    const o = gt[n][1], i = Math.abs(o - e), u = Math.abs(r - e);
    return i < u ? n : a;
  }, 0);
  return gt[t][0];
}
function Jf(e, t) {
  if (mr[t])
    return t;
  if (e.length === 1)
    return "15seconds";
  const n = Df(e), r = Cr(n);
  return xf(r);
}
function ze(e) {
  const { s: t, m: n, H: r } = tt(e);
  return r === 0 && n === 0 && t === 0;
}
function Re(e, t) {
  const n = tt(e).M, r = tt(t).M;
  return n !== r;
}
function ue(e) {
  const { M: t, d: n, s: r, m: a, H: o } = tt(e);
  return t === 1 && n === 1 && o === 0 && a === 0 && r === 0;
}
function Zf(e) {
  return e === void 0 ? "" : e.toISOString();
}
var Lf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function If(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pr = { exports: {} };
/*! dom-to-image-more 26-04-2023 */
(function(e, t) {
  (function(n) {
    const r = function() {
      let w = 0;
      return { escape: function(s) {
        return s.replace(/([.*+?^${}()|[]\/\\])/g, "\\$1");
      }, isDataUrl: function(s) {
        return s.search(/^(data:)/) !== -1;
      }, canvasToBlob: function(s) {
        return s.toBlob ? new Promise(function(d) {
          s.toBlob(d);
        }) : function(d) {
          return new Promise(function(h) {
            var p = C(d.toDataURL().split(",")[1]), S = p.length, j = new Uint8Array(S);
            for (let $ = 0; $ < S; $++)
              j[$] = p.charCodeAt($);
            h(new Blob([j], { type: "image/png" }));
          });
        }(s);
      }, resolveUrl: function(s, d) {
        var h = document.implementation.createHTMLDocument(), p = h.createElement("base"), S = (h.head.appendChild(p), h.createElement("a"));
        return h.body.appendChild(S), p.href = d, S.href = s, S.href;
      }, getAndEncode: function(s) {
        let d = f.impl.urlCache.find(function(h) {
          return h.url === s;
        });
        return d || (d = { url: s, promise: null }, f.impl.urlCache.push(d)), d.promise === null && (f.impl.options.cacheBust && (s += (/\?/.test(s) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime()), d.promise = new Promise(function(h) {
          const p = f.impl.options.httpTimeout, S = new XMLHttpRequest();
          S.onreadystatechange = function() {
            if (S.readyState === 4)
              if (S.status !== 200)
                j ? h(j) : N(`cannot fetch resource: ${s}, status: ` + S.status);
              else {
                const I = new FileReader();
                I.onloadend = function() {
                  h(I.result);
                }, I.readAsDataURL(S.response);
              }
          }, S.ontimeout = function() {
            j ? h(j) : N(`timeout of ${p}ms occured while fetching resource: ` + s);
          }, S.responseType = "blob", S.timeout = p, f.impl.options.useCredentials && (S.withCredentials = !0), S.open("GET", s, !0), S.send();
          let j;
          var $;
          function N(I) {
            console.error(I), h("");
          }
          f.impl.options.imagePlaceholder && ($ = f.impl.options.imagePlaceholder.split(/,/)) && $[1] && (j = $[1]);
        })), d.promise;
      }, uid: function() {
        return "u" + ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4) + w++;
      }, delay: function(s) {
        return function(d) {
          return new Promise(function(h) {
            setTimeout(function() {
              h(d);
            }, s);
          });
        };
      }, asArray: function(s) {
        var d = [], h = s.length;
        for (let p = 0; p < h; p++)
          d.push(s[p]);
        return d;
      }, escapeXhtml: function(s) {
        return s.replace(/%/g, "%25").replace(/#/g, "%23").replace(/\n/g, "%0A");
      }, makeImage: function(s) {
        return s !== "data:," ? new Promise(function(d, h) {
          const p = new Image();
          f.impl.options.useCredentials && (p.crossOrigin = "use-credentials"), p.onload = function() {
            window && window.requestAnimationFrame ? window.requestAnimationFrame(function() {
              d(p);
            }) : d(p);
          }, p.onerror = h, p.src = s;
        }) : Promise.resolve();
      }, width: function(s) {
        var d = O(s, "width");
        if (!isNaN(d))
          return d;
        var d = O(s, "border-left-width"), h = O(s, "border-right-width");
        return s.scrollWidth + d + h;
      }, height: function(s) {
        var d = O(s, "height");
        if (!isNaN(d))
          return d;
        var d = O(s, "border-top-width"), h = O(s, "border-bottom-width");
        return s.scrollHeight + d + h;
      }, getWindow: c, isElement: T, isElementHostForOpenShadowRoot: function(s) {
        return T(s) && s.shadowRoot !== null;
      }, isShadowRoot: y, isInShadowRoot: E, isHTMLElement: function(s) {
        return s instanceof c(s).HTMLElement;
      }, isHTMLCanvasElement: function(s) {
        return s instanceof c(s).HTMLCanvasElement;
      }, isHTMLInputElement: function(s) {
        return s instanceof c(s).HTMLInputElement;
      }, isHTMLImageElement: function(s) {
        return s instanceof c(s).HTMLImageElement;
      }, isHTMLLinkElement: function(s) {
        return s instanceof c(s).HTMLLinkElement;
      }, isHTMLScriptElement: function(s) {
        return s instanceof c(s).HTMLScriptElement;
      }, isHTMLStyleElement: function(s) {
        return s instanceof c(s).HTMLStyleElement;
      }, isHTMLTextAreaElement: function(s) {
        return s instanceof c(s).HTMLTextAreaElement;
      }, isShadowSlotElement: function(s) {
        return E(s) && s instanceof c(s).HTMLSlotElement;
      }, isSVGElement: function(s) {
        return s instanceof c(s).SVGElement;
      }, isSVGRectElement: function(s) {
        return s instanceof c(s).SVGRectElement;
      }, isDimensionMissing: function(s) {
        return isNaN(s) || s <= 0;
      } };
      function c(s) {
        return s = s ? s.ownerDocument : void 0, (s ? s.defaultView : void 0) || n || window;
      }
      function y(s) {
        return s instanceof c(s).ShadowRoot;
      }
      function E(s) {
        return s !== null && Object.prototype.hasOwnProperty.call(s, "getRootNode") && y(s.getRootNode());
      }
      function T(s) {
        return s instanceof c(s).Element;
      }
      function O(s, d) {
        if (s.nodeType === m) {
          let h = v(s).getPropertyValue(d);
          if (h.slice(-2) === "px")
            return h = h.slice(0, -2), parseFloat(h);
        }
        return NaN;
      }
    }(), a = function() {
      const w = /url\(['"]?([^'"]+?)['"]?\)/g;
      return { inlineAll: function(T, O, s) {
        return c(T) ? Promise.resolve(T).then(y).then(function(d) {
          let h = Promise.resolve(T);
          return d.forEach(function(p) {
            h = h.then(function(S) {
              return E(S, p, O, s);
            });
          }), h;
        }) : Promise.resolve(T);
      }, shouldProcess: c, impl: { readUrls: y, inline: E } };
      function c(T) {
        return T.search(w) !== -1;
      }
      function y(T) {
        for (var O, s = []; (O = w.exec(T)) !== null; )
          s.push(O[1]);
        return s.filter(function(d) {
          return !r.isDataUrl(d);
        });
      }
      function E(T, O, s, d) {
        return Promise.resolve(O).then(function(h) {
          return s ? r.resolveUrl(h, s) : h;
        }).then(d || r.getAndEncode).then(function(h) {
          return T.replace((p = O, new RegExp(`(url\\(['"]?)(${r.escape(p)})(['"]?\\))`, "g")), `$1${h}$3`);
          var p;
        });
      }
    }(), o = { resolveAll: function() {
      return i().then(function(w) {
        return Promise.all(w.map(function(c) {
          return c.resolve();
        }));
      }).then(function(w) {
        return w.join(`
`);
      });
    }, impl: { readAll: i } };
    function i() {
      return Promise.resolve(r.asArray(document.styleSheets)).then(function(c) {
        const y = [];
        return c.forEach(function(E) {
          if (Object.prototype.hasOwnProperty.call(Object.getPrototypeOf(E), "cssRules"))
            try {
              r.asArray(E.cssRules || []).forEach(y.push.bind(y));
            } catch (T) {
              console.error("domtoimage: Error while reading CSS rules from " + E.href, T.toString());
            }
        }), y;
      }).then(function(c) {
        return c.filter(function(y) {
          return y.type === CSSRule.FONT_FACE_RULE;
        }).filter(function(y) {
          return a.shouldProcess(y.style.getPropertyValue("src"));
        });
      }).then(function(c) {
        return c.map(w);
      });
      function w(c) {
        return { resolve: function() {
          var y = (c.parentStyleSheet || {}).href;
          return a.inlineAll(c.cssText, y);
        }, src: function() {
          return c.style.getPropertyValue("src");
        } };
      }
    }
    const u = { inlineAll: function w(c) {
      if (!r.isElement(c))
        return Promise.resolve(c);
      return y(c).then(function() {
        return r.isHTMLImageElement(c) ? l(c).inline() : Promise.all(r.asArray(c.childNodes).map(function(E) {
          return w(E);
        }));
      });
      function y(E) {
        const T = ["background", "background-image"], O = T.map(function(s) {
          const d = E.style.getPropertyValue(s), h = E.style.getPropertyPriority(s);
          return d ? a.inlineAll(d).then(function(p) {
            E.style.setProperty(s, p, h);
          }) : Promise.resolve();
        });
        return Promise.all(O).then(function() {
          return E;
        });
      }
    }, impl: { newImage: l } };
    function l(w) {
      return { inline: function(c) {
        return r.isDataUrl(w.src) ? Promise.resolve() : Promise.resolve(w.src).then(c || r.getAndEncode).then(function(y) {
          return new Promise(function(E) {
            w.onload = E, w.onerror = E, w.src = y;
          });
        });
      } };
    }
    const g = { copyDefaultStyles: !0, imagePlaceholder: void 0, cacheBust: !1, useCredentials: !1, httpTimeout: 3e4, styleCaching: "strict" }, f = { toSvg: M, toPng: function(w, c) {
      return x(w, c).then(function(y) {
        return y.toDataURL();
      });
    }, toJpeg: function(w, c) {
      return x(w, c).then(function(y) {
        return y.toDataURL("image/jpeg", (c ? c.quality : void 0) || 1);
      });
    }, toBlob: function(w, c) {
      return x(w, c).then(r.canvasToBlob);
    }, toPixelData: function(w, c) {
      return x(w, c).then(function(y) {
        return y.getContext("2d").getImageData(0, 0, r.width(w), r.height(w)).data;
      });
    }, toCanvas: x, impl: { fontFaces: o, images: u, util: r, inliner: a, urlCache: [], options: {} } }, m = (e.exports = f, (typeof Node < "u" ? Node.ELEMENT_NODE : void 0) || 1), v = (n !== void 0 ? n.getComputedStyle : void 0) || (typeof window < "u" ? window.getComputedStyle : void 0) || globalThis.getComputedStyle, C = (n !== void 0 ? n.atob : void 0) || (typeof window < "u" ? window.atob : void 0) || globalThis.atob;
    function M(w, c) {
      f.impl.util.getWindow(w);
      var y = c = c || {};
      y.copyDefaultStyles === void 0 ? f.impl.options.copyDefaultStyles = g.copyDefaultStyles : f.impl.options.copyDefaultStyles = y.copyDefaultStyles, y.imagePlaceholder === void 0 ? f.impl.options.imagePlaceholder = g.imagePlaceholder : f.impl.options.imagePlaceholder = y.imagePlaceholder, y.cacheBust === void 0 ? f.impl.options.cacheBust = g.cacheBust : f.impl.options.cacheBust = y.cacheBust, y.useCredentials === void 0 ? f.impl.options.useCredentials = g.useCredentials : f.impl.options.useCredentials = y.useCredentials, y.httpTimeout === void 0 ? f.impl.options.httpTimeout = g.httpTimeout : f.impl.options.httpTimeout = y.httpTimeout, y.styleCaching === void 0 ? f.impl.options.styleCaching = g.styleCaching : f.impl.options.styleCaching = y.styleCaching;
      let E = [];
      return Promise.resolve(w).then(function(T) {
        if (T.nodeType === m)
          return T;
        var O = T, s = T.parentNode, d = document.createElement("span");
        return s.replaceChild(d, O), d.append(T), E.push({ parent: s, child: O, wrapper: d }), d;
      }).then(function(T) {
        return function O(s, d, h, p) {
          const S = d.filter;
          if (s === P || r.isHTMLScriptElement(s) || r.isHTMLStyleElement(s) || r.isHTMLLinkElement(s) || h !== null && S && !S(s))
            return Promise.resolve();
          return Promise.resolve(s).then(j).then(function(b) {
            return N(b, $(s));
          }).then(function(b) {
            return I(b, s);
          });
          function j(b) {
            return r.isHTMLCanvasElement(b) ? r.makeImage(b.toDataURL()) : b.cloneNode(!1);
          }
          function $(b) {
            return r.isElementHostForOpenShadowRoot(b) ? b.shadowRoot : b;
          }
          function N(b, W) {
            const ce = Te(W);
            let te = Promise.resolve();
            if (ce.length !== 0) {
              const H = v(fe(W));
              r.asArray(ce).forEach(function(X) {
                te = te.then(function() {
                  return O(X, d, H).then(function(R) {
                    R && b.appendChild(R);
                  });
                });
              });
            }
            return te.then(function() {
              return b;
            });
            function fe(H) {
              return r.isShadowRoot(H) ? H.host : H;
            }
            function Te(H) {
              return r.isShadowSlotElement(H) ? H.assignedNodes() : H.childNodes;
            }
          }
          function I(b, W) {
            return !r.isElement(b) || r.isShadowSlotElement(W) ? Promise.resolve(b) : Promise.resolve().then(ce).then(te).then(fe).then(Te).then(function() {
              return b;
            });
            function ce() {
              function H(R, D) {
                D.font = R.font, D.fontFamily = R.fontFamily, D.fontFeatureSettings = R.fontFeatureSettings, D.fontKerning = R.fontKerning, D.fontSize = R.fontSize, D.fontStretch = R.fontStretch, D.fontStyle = R.fontStyle, D.fontVariant = R.fontVariant, D.fontVariantCaps = R.fontVariantCaps, D.fontVariantEastAsian = R.fontVariantEastAsian, D.fontVariantLigatures = R.fontVariantLigatures, D.fontVariantNumeric = R.fontVariantNumeric, D.fontVariationSettings = R.fontVariationSettings, D.fontWeight = R.fontWeight;
              }
              function X(R, D) {
                const ie = v(R);
                ie.cssText ? (D.style.cssText = ie.cssText, H(ie, D.style)) : (oe(d, R, ie, h, D), h === null && (["inset-block", "inset-block-start", "inset-block-end"].forEach((Se) => D.style.removeProperty(Se)), ["left", "right", "top", "bottom"].forEach((Se) => {
                  D.style.getPropertyValue(Se) && D.style.setProperty(Se, "0px");
                })));
              }
              X(W, b);
            }
            function te() {
              const H = r.uid();
              function X(R) {
                const D = v(W, R), ie = D.getPropertyValue("content");
                if (ie !== "" && ie !== "none") {
                  let yr = function() {
                    const vr = `.${H}:` + R, br = (D.cssText ? wr : Tr)();
                    return document.createTextNode(vr + `{${br}}`);
                    function wr() {
                      return `${D.cssText} content: ${ie};`;
                    }
                    function Tr() {
                      return r.asArray(D).map(Sr).join("; ") + ";";
                      function Sr(lt) {
                        const Or = D.getPropertyValue(lt), Pr = D.getPropertyPriority(lt) ? " !important" : "";
                        return lt + ": " + Or + Pr;
                      }
                    }
                  };
                  const Se = b.getAttribute("class") || "", Ht = (b.setAttribute("class", Se + " " + H), document.createElement("style"));
                  Ht.appendChild(yr()), b.appendChild(Ht);
                }
              }
              [":before", ":after"].forEach(function(R) {
                X(R);
              });
            }
            function fe() {
              r.isHTMLTextAreaElement(W) && (b.innerHTML = W.value), r.isHTMLInputElement(W) && b.setAttribute("value", W.value);
            }
            function Te() {
              r.isSVGElement(b) && (b.setAttribute("xmlns", "http://www.w3.org/2000/svg"), r.isSVGRectElement(b)) && ["width", "height"].forEach(function(H) {
                const X = b.getAttribute(H);
                X && b.style.setProperty(H, X);
              });
            }
          }
        }(T, c, null);
      }).then(U).then(q).then(function(T) {
        c.bgcolor && (T.style.backgroundColor = c.bgcolor), c.width && (T.style.width = c.width + "px"), c.height && (T.style.height = c.height + "px"), c.style && Object.keys(c.style).forEach(function(s) {
          T.style[s] = c.style[s];
        });
        let O = null;
        return typeof c.onclone == "function" && (O = c.onclone(T)), Promise.resolve(O).then(function() {
          return T;
        });
      }).then(function(T) {
        let O = c.width || r.width(T), s = c.height || r.height(T);
        return Promise.resolve(T).then(function(d) {
          return d.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), new XMLSerializer().serializeToString(d);
        }).then(r.escapeXhtml).then(function(d) {
          var h = (r.isDimensionMissing(O) ? ' width="100%"' : ` width="${O}"`) + (r.isDimensionMissing(s) ? ' height="100%"' : ` height="${s}"`);
          return `<svg xmlns="http://www.w3.org/2000/svg"${(r.isDimensionMissing(O) ? "" : ` width="${O}"`) + (r.isDimensionMissing(s) ? "" : ` height="${s}"`)}><foreignObject${h}>${d}</foreignObject></svg>`;
        }).then(function(d) {
          return "data:image/svg+xml;charset=utf-8," + d;
        });
      }).then(function(T) {
        for (; 0 < E.length; ) {
          var O = E.pop();
          O.parent.replaceChild(O.child, O.wrapper);
        }
        return T;
      }).then(function(T) {
        return f.impl.urlCache = [], function() {
          P && (document.body.removeChild(P), P = null), V && clearTimeout(V), V = setTimeout(() => {
            V = null, Q = {};
          }, 2e4);
        }(), T;
      });
    }
    function x(w, c) {
      return M(w, c = c || {}).then(r.makeImage).then(function(y) {
        var E = typeof c.scale != "number" ? 1 : c.scale, T = function(s, d) {
          let h = c.width || r.width(s), p = c.height || r.height(s);
          return r.isDimensionMissing(h) && (h = r.isDimensionMissing(p) ? 300 : 2 * p), r.isDimensionMissing(p) && (p = h / 2), s = document.createElement("canvas"), s.width = h * d, s.height = p * d, c.bgcolor && ((d = s.getContext("2d")).fillStyle = c.bgcolor, d.fillRect(0, 0, s.width, s.height)), s;
        }(w, E), O = T.getContext("2d");
        return O.msImageSmoothingEnabled = !1, O.imageSmoothingEnabled = !1, y && (O.scale(E, E), O.drawImage(y, 0, 0)), T;
      });
    }
    let P = null;
    function U(w) {
      return o.resolveAll().then(function(c) {
        var y;
        return c !== "" && (y = document.createElement("style"), w.appendChild(y), y.appendChild(document.createTextNode(c))), w;
      });
    }
    function q(w) {
      return u.inlineAll(w).then(function() {
        return w;
      });
    }
    function oe(w, c, y, E, T) {
      const O = f.impl.options.copyDefaultStyles ? function(d, S) {
        var S = function($) {
          var N = [];
          do
            if ($.nodeType === m) {
              var I = $.tagName;
              if (N.push(I), le.includes(I))
                break;
            }
          while ($ = $.parentNode, $);
          return N;
        }(S), p = function($) {
          return (d.styleCaching !== "relaxed" ? $ : $.filter((N, I, b) => I === 0 || I === b.length - 1)).join(">");
        }(S);
        if (Q[p])
          return Q[p];
        var j = function() {
          if (P)
            return P.contentWindow;
          var $ = document.characterSet || "UTF-8", N = document.doctype, N = N ? (`<!DOCTYPE ${I(N.name)} ${I(N.publicId)} ` + I(N.systemId)).trim() + ">" : "";
          return (P = document.createElement("iframe")).id = "domtoimage-sandbox-" + r.uid(), P.style.visibility = "hidden", P.style.position = "fixed", document.body.appendChild(P), function(b, W, ce, te) {
            try {
              return b.contentWindow.document.write(W + `<html><head><meta charset='${ce}'><title>${te}</title></head><body></body></html>`), b.contentWindow;
            } catch {
            }
            var fe = document.createElement("meta");
            fe.setAttribute("charset", ce);
            try {
              var Te = document.implementation.createHTMLDocument(te), H = (Te.head.appendChild(fe), W + Te.documentElement.outerHTML);
              return b.setAttribute("srcdoc", H), b.contentWindow;
            } catch {
            }
            return b.contentDocument.head.appendChild(fe), b.contentDocument.title = te, b.contentWindow;
          }(P, N, $, "domtoimage-sandbox");
          function I(b) {
            var W;
            return b ? ((W = document.createElement("div")).innerText = b, W.innerHTML) : "";
          }
        }(), S = function($, N) {
          let I = $.body;
          do {
            var b = N.pop(), b = $.createElement(b);
            I.appendChild(b), I = b;
          } while (0 < N.length);
          return I.textContent = "​", I;
        }(j.document, S), j = function($, N) {
          const I = {}, b = $.getComputedStyle(N);
          return r.asArray(b).forEach(function(W) {
            I[W] = W === "width" || W === "height" ? "auto" : b.getPropertyValue(W);
          }), I;
        }(j, S);
        return function($) {
          do {
            var N = $.parentElement;
            N !== null && N.removeChild($), $ = N;
          } while ($ && $.tagName !== "BODY");
        }(S), Q[p] = j;
      }(w, c) : {}, s = T.style;
      r.asArray(y).forEach(function(d) {
        var h, p = y.getPropertyValue(d), S = O[d], j = E ? E.getPropertyValue(d) : void 0;
        (p !== S || E && p !== j) && (S = y.getPropertyPriority(d), j = s, p = p, S = S, h = 0 <= ["background-clip"].indexOf(d = d), S ? (j.setProperty(d, p, S), h && j.setProperty("-webkit-" + d, p, S)) : (j.setProperty(d, p), h && j.setProperty("-webkit-" + d, p)));
      });
    }
    let V = null, Q = {};
    const le = ["ADDRESS", "ARTICLE", "ASIDE", "BLOCKQUOTE", "DETAILS", "DIALOG", "DD", "DIV", "DL", "DT", "FIELDSET", "FIGCAPTION", "FIGURE", "FOOTER", "FORM", "H1", "H2", "H3", "H4", "H5", "H6", "HEADER", "HGROUP", "HR", "LI", "MAIN", "NAV", "OL", "P", "PRE", "SECTION", "SVG", "TABLE", "UL", "math", "svg", "BODY", "HEAD", "HTML"];
  })(Lf);
})(pr);
var Rf = pr.exports;
const ed = /* @__PURE__ */ If(Rf);
function Ff(e) {
  const t = Mr(e, (r) => r.value), n = $r().domain(t).nice().domain();
  if (n[0] > 0)
    n[0] = 0;
  else if (n[0] === 0 && n[1] === 0)
    return [0, 1];
  return n[0] < 0 && n[1] > 0 && (Math.abs(n[0]) > n[1] ? n[1] = Math.abs(n[0]) : n[0] = -n[1]), n;
}
function td(e, t) {
  const n = ge(t, "gradient", "colors"), r = !zc(n);
  let a = ge(t, "pairing", "option");
  const o = Ff(e), i = o[0] < 0 && o[1] > 0 ? "diverge" : "mono";
  (a < 1 && a > 4 && i === "mono" || a < 1 && a > 2 && i === "diverge") && (a = 1);
  const u = r ? n : [];
  if (!r) {
    const l = i === "diverge" ? 17 : 11;
    for (let g = 1; g < l + 1; g++)
      u.push(`fill-${i}-${a}-${g}`);
  }
  return Ar().domain(o).range(u);
}
export {
  If as $,
  ro as A,
  ao as B,
  Xf as C,
  oo as D,
  io as E,
  ur as F,
  lo as G,
  Ge as H,
  co as I,
  fo as J,
  ho as K,
  go as L,
  Jf as M,
  Zf as N,
  Kf as O,
  td as P,
  Ff as Q,
  tt as R,
  Af as S,
  gt as T,
  G as U,
  Mo as V,
  Rc as W,
  Bn as X,
  Ut as Y,
  Xl as Z,
  Ti as _,
  Pt as a,
  eu as a0,
  zf as a1,
  pt as a2,
  zc as a3,
  kf as a4,
  qf as a5,
  Gf as a6,
  Yf as a7,
  Qf as a8,
  af as a9,
  Vf as aa,
  Hf as ab,
  uo as ac,
  Mt as ad,
  rf as ae,
  B as af,
  Z as ag,
  me as ah,
  Ur as ai,
  Wr as aj,
  Uc as b,
  ne as c,
  ka as d,
  ed as e,
  nf as f,
  ge as g,
  _ as h,
  Ye as i,
  so as j,
  ot as k,
  Xa as l,
  Bf as m,
  Ka as n,
  $f as o,
  jt as p,
  eo as q,
  ee as r,
  Ja as s,
  Js as t,
  Cn as u,
  Za as v,
  Mn as w,
  sr as x,
  to as y,
  no as z
};
//# sourceMappingURL=color-scale-utils-38aedd61.mjs.map
